import { jsx as _jsx } from "preact/jsx-runtime";
import { Suspense } from 'preact/compat';
import { Await, useLoaderData, useParams } from 'react-router';
import '@etchteam/diamond-ui/composition/Enter/Enter';
import '@/components/composition/Wrap/Wrap';
import MaterialCategoriesNav from '@/components/control/MaterialCategoriesNav/MaterialCategoriesNav';
export default function CategoriesPage() {
    const { postcode } = useParams();
    const { materialCategories: materialCategoriesPromise } = useLoaderData();
    return (_jsx(Suspense, { fallback: null, children: _jsx(Await, { resolve: materialCategoriesPromise, children: (materialCategories) => (_jsx("diamond-enter", { type: "fade", children: _jsx(MaterialCategoriesNav, { basePath: `/${postcode}/places`, materialCategories: materialCategories }) })) }) }));
}
